import { render, staticRenderFns } from "./CardLoader.vue?vue&type=template&id=fd82a636&scoped=true&"
import script from "./CardLoader.vue?vue&type=script&lang=js&"
export * from "./CardLoader.vue?vue&type=script&lang=js&"
import style0 from "./CardLoader.vue?vue&type=style&index=0&id=fd82a636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd82a636",
  null
  
)

export default component.exports